module.exports = __webpack_public_path__ + "static/media/kover.f9ea11da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/assets/kover.png
// module id = 44
// module chunks = 0